import React, { useMemo } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';
import { useFormContext, Controller } from 'react-hook-form';
import { useFeatureFlag } from 'modules/common/hooks/useFeatureFlag';
import { EnabledDisabled } from './constant';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1.5, 1, 1, 2),
      width: theme.spacing(16)
    }
  })
);
type SimpleDropDown = {
  value?: EnabledDisabled;
  options: {
    key: EnabledDisabled;
    value: string;
  }[];
  rowID: string;
  label?: string;
};

export const SimpleDropDown: React.FC<SimpleDropDown> = ({
  value,
  options,
  rowID,
  label
}: SimpleDropDown) => {
  const classes = useStyles();
  const { control } = useFormContext();
  const dropDownName = useMemo(() => `${rowID}.enableDisabled`, [rowID]);

  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');
  const inputProp = useMemo(
    () => ({
      'aria-label': isTiwScreenReaderEnabled ? label : ''
    }),
    [isTiwScreenReaderEnabled, label]
  );

  return (
    <div>
      <Controller
        render={({ field }) => (
          <TextField
            data-testid={`setting-drop-down-${rowID}`}
            select
            size="small"
            className={classes.root}
            variant="outlined"
            SelectProps={{ native: true }}
            {...field}
            inputProps={inputProp}
          >
            {options.map((option) => (
              <option key={option.key} value={option.key}>
                {option.value}
              </option>
            ))}
          </TextField>
        )}
        name={dropDownName}
        control={control}
        defaultValue={value || EnabledDisabled.enabled}
      />
    </div>
  );
};
